
import $ from "jquery"
import Promise from "plugins/bluebird"

/* eslint-disable no-unused-vars */
import * as IntroJs from "intro.js"
/* eslint-enable no-unused-vars */


import I18n from "plugins/i18n-js"


const init = (steps: IntroJs.Step[]): Promise<IntroJs.IntroJs> => {
  if ( Object.prototype.toString.call(steps) !== "[object Array]" ){
    throw new Error("steps is not array")
  }

  if (steps.length === 0){
    throw new Error("steps is empty")
  }

  const $body = $("body")
  const prevLabel = I18n.t("actions.defaults.go_to_previous_step")
  const skipLabel = I18n.t("actions.defaults.skip")
  const understandLabel = I18n.t("actions.defaults.understand")

  // Scroll to top to avoid user unable to dismiss tutorial
  $body.scrollTop(0)

  // disable scrolling until tutorial is completed
  $body.css("overflow-y", "hidden")

  return Promise.resolve(
    import(
      "intro.js"
    )
    .then(({default: introJs}) => {

      const intro_obj = introJs()
      intro_obj
      .oncomplete(() => {
        // enable scrolling after tutorial is completed (pressing skip does not count)
        $body.css("overflow-y", "auto")
      })
      .onexit(() => {
        // enable scrolling after tutorial is exited (like pressing skip)
        $body.css("overflow-y", "auto")
      })

      // Doc for options
      // http://introjs.com/docs/
      intro_obj.setOptions({
        showStepNumbers:    false,
        nextLabel:          understandLabel,
        prevLabel:          prevLabel,
        skipLabel:          skipLabel,
        doneLabel:          understandLabel,
        exitOnOverlayClick: true,
        disableInteraction: true,

        steps: steps,

        // When there is only one step
        // Clicking on bullet will cause a error (due to plugin bug)
        // So we don't show it when there is only 1 step
        //
        // Assumed steps non-empty
        //
        // Related issues on the plugin:
        // - https://github.com/usablica/intro.js/issues/136
        // - https://github.com/usablica/intro.js/pull/489
        showBullets: false,
      })

      return intro_obj
    }),
  )
}


export default {
  init,
}
